import { IListResponse, XHRInstance } from "@sembark-travel/xhr"
import type { TOtaMealPlan } from "../HotelOtaMealPlans"
import type { TAmenity } from "../Amenities"
import type { THotelPaxTypeCode } from "../Hotels"

export type TOtaRoomType = {
	id: number
	name: string
	base_adult_occupancy: number
	base_child_occupancy: number
	max_occupancy: number
	max_adult_occupancy: number
	max_child_occupancy: number
	no_of_rooms: number
	includes_all_meal_plans: boolean
	order: number
}

// How many of a pax type a room is configured to hold at an occupancy.
// `occupancy` carries the age range of the pax type, e.g. "CNB (6-12)".
export type TOtaRoomTypePaxTypeConfig = {
	pax_type: THotelPaxTypeCode
	occupancy: string
	pax_count: number
}

// A hotel's room type, with everything it is sold with
export type THotelOtaRoomType = TOtaRoomType & {
	ota_meal_plans: TOtaMealPlan[]
	pax_types: TOtaRoomTypePaxTypeConfig[]
	pax_types_with_lower_occupancies_configuration: TOtaRoomTypePaxTypeConfig[]
}

export type TOtaRoomTypeWithMedia = TOtaRoomType & {
	ota_meal_plans: TOtaMealPlan[]
	image_url: string
	thumb_image_url: string
	amenities: TAmenity[]
}

export function hotelOtaRoomTypesXHR(xhr: XHRInstance) {
	return {
		async getOtaRoomTypes(
			hotelId: string | number,
			params?: Record<string, unknown>
		): Promise<IListResponse<TOtaRoomTypeWithMedia>> {
			return xhr
				.get(`/hotels/${hotelId}/ota-room-types`, { params })
				.then((resp) => resp.data)
		},
		async createOtaRoomType(
			hotelId: string | number,
			data: FormData
		): Promise<TOtaRoomTypeWithMedia> {
			return xhr
				.post(`/hotels/${hotelId}/ota-room-types`, data)
				.then((resp) => resp.data.data)
		},
		async updateOtaRoomType(
			hotelId: string | number,
			id: number,
			data: FormData
		): Promise<TOtaRoomTypeWithMedia> {
			return xhr
				.put(`/hotels/${hotelId}/ota-room-types/${id}`, data)
				.then((resp) => resp.data.data)
		},
		async deleteOtaRoomType(id: number): Promise<{ message: string }> {
			return xhr.delete(`/ota-room-types/${id}`).then((resp) => resp.data.data)
		},
		async reorderOtaRoomTypes(
			hotelId: string | number,
			roomTypes: Array<{ id: number; order: number }>
		): Promise<{ message: string }> {
			return xhr
				.post(`/hotels/${hotelId}/ota-room-types-reorder`, {
					room_types: roomTypes,
				})
				.then((resp) => resp.data.data)
		},
	}
}
